import React from "react";
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from "../../util/methods";
import {
  clearProps,
  createResource,
  deleteResource,
  fetchActivitySno,
  fetchFormData,
  fetchQuotations,
  fetchResource,
  fetchTpwNo,
  getResource,
  getResourceForDownload,
  saveResourceQuery,
  setValueForTotal,
  setValueForTotalLabour,
  setValueForTotalSpare,
  updateResource,
  updateVendor
} from "../../appRedux/actions/InvoiceEntry";
import {fetchFilter, fetchSubDocumentFilter,} from "../../appRedux/actions";
import {connect} from "react-redux";
import {Route, Switch} from "react-router-dom";
import Create from "../InvoiceEntry/create";
import AccessControl from "../../components/AccessControl";
import {Button, Popconfirm} from "antd";
import List from "../../components/List";
import * as _ from 'lodash';

class InvoiceEntry extends React.Component {

  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {},
  };

  state = {
    value: 'tpwNo',
    fields: {
      name: {
        value: '',
      },
      description: {
        value: ''
      }
    },
    query: this.initialQueryState,
    columns: [],
    visibleColumns: []
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    this.fetchList();
    this.props.fetchFilter(this.props.resourceName);
    this.props.fetchSubDocumentFilter('Document');
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) =>
        Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
      this.setState({visibleColumns: columns}, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      })
    }
  }

  handleColumnChange = (value, array) => {
    const {filters} = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = {...this.props.query};
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = {...this.props.query};
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  handleChange = (pagination, filters, sorter) => {
    const query = {...this.props.query};
    query.pagination = {...query.pagination, current: pagination.current};
    query.sort = sorter;

    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleFormChange = (changedFields) => {
    this.setState(({fields}) => ({
      fields: {...fields, ...changedFields},
    }));
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const {resourceName} = this.props;
    Object.keys(filters).forEach((item) => {

      if(item === '_id') {
        return;
      }

      if(selectedColumns.indexOf(item) === -1) {
        return;
      }
      columns.push({
        title: sanitizeFieldName(item),
        dataIndex: filters[item].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters[item].type, item),
        ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
      })
    });

    columns.push({
      title: 'Action',
      key: 'action',
      render: (record) => (
        <div>

          {/*<AccessControl resource={this.props.resourceName} permissionNeeded={'u'}*/}
          {/*               roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {*/}
          {/*  return <Button type="primary" size='small' onClick={() => this.edit(record._id)}>Edit</Button>;*/}
          {/*}}/>*/}
          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Button type="primary" size='small' onClick={() => this.edit(record._id)}>View</Button>
          }}/>

          <AccessControl resource={this.props.resourceName} permissionNeeded={'d'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={() => {
                this.deleteResource(record._id);
              }}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              <Button style={{marginLeft: '10px'}} type="danger" size='small'>Delete</Button>
            </Popconfirm>;
          }}/>
        </div>
      ),
    });

    this.setState({
      visibleColumns: selectedColumns,
      columns
    })
  };

  // clearAll = () => {
  //   this.props.saveResourceQuery(this.initialQueryState);
  //   this.fetchList();
  // };

  clearAll = () => {
    const clearQueryState = {
      sort: {
        field: '',
        order: ''
      },
      pagination: {
        pageSize: 10,
        current: 1
      },
      filters: {},
    };
    //this.props.saveResourceQuery(this.initialQueryState);
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
  };

  fetchList = () => {
    this.props.getResource();
  };

  create = () => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  edit = (id) => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/edit/${id}`);
  };

  updateValue = (data) => {
    this.setState({value: data});
  }

  storeTotalData = (data, field, ind, index = null) => {
    if(this.state.value === 'tpwNo') {
      this.props.setValueForTotal({data: data});
    }
    else {
      if(field === 'spareRequired') {
        this.props.setValueForTotalSpare({data: data, index: ind, removeIndex: index});
      }
      else if(field === 'labourRequired') {
        this.props.setValueForTotalLabour({data: data, index: ind, removeIndex: index});
      }
    }
  };

  downloadToCSV = () => {
    const columns = [];
    this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
    this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, "InvoiceEntry");
  }

  fetchTpwNo = (tpwSearchQuery) => {
    const data = {
      tpwSearchQuery: tpwSearchQuery,
    };
    this.props.fetchTpwNo(data);
  }

  createResource = (values) => {
    values.documents = values.invoiceData && values.invoiceData.documents || [];
    this.props.createResource(values);
  };
  updateResource = (values, id) => {
    // values.documents = values.documents || [];
    this.props.updateResource(values, id);
  };
  deleteResource = (id) => {
    this.props.deleteResource(id);
  };

  fetchFormData = (values) => {
    this.props.fetchFormData(values);
  };

  render() {
    const {match, data, resource, edit, fetchResource, loading, filters, modules, authUser, resourceName} = this.props;
    const {columns, visibleColumns} = this.state;
    faviconDynamicFunction(authUser);
    return (<div>
      <h2>{sanitizeFieldName(resourceName)}</h2>
      <Switch>
        <Route path={`${match.url}`} exact
               render={() => <List columns={columns}
                                   visibleColumn={visibleColumns}
                                   data={data}
                                   clearFilter={this.clearAll}
                                   filters={filters}
                                   handleChange={this.handleChange}
                                   columnChange={this.handleColumnChange}
                                   downloadToCSV={this.downloadToCSV}
                                   title={resourceName}
                                   size={'middle'}
                                   create={this.create}
                                   pagination={this.props.query.pagination}
                                   loading={loading}
                                   authUser={authUser}
               />
               }/>

        <Route path={`${match.url}/add`}
               render={(props) => <Create data={{}}
                                          resource={resourceName}
                                          title={'CREATE'}
                                          filters={filters}
                                          modules={modules}
                                          searchData={this.props.searchData}
                                          onSubmit={this.createResource}
                                          forModalSubmit={this.fetchFormData}
                                          fetchTpwNo={this.fetchTpwNo}
                                          fetchQuotations={this.props.fetchQuotations}
                                          tpw={this.props.tpw}
                                          cancelTpw={this.props.cancelTpw}
                                          clearProps={this.props.clearProps}
                                          labourData={this.props.labourData}
                                          sparesData={this.props.sparesData}
                                          activities={this.props.activities}
                                          storeTotalData={this.storeTotalData}
                                          fetchActivitySno={this.props.fetchActivitySno}
                                          quotations={this.props.quotations}
                                          changed={this.props.changed}
                                          totalData={this.props.totalData}
                                          tableData={this.props.tableData}
                                          subDocumentFilters={this.props.subDocumentFilters}
                                          loading={loading}
                                          authUser={authUser}
                                          updateValue={this.updateValue}
                                          {...props}
               />
               }/>
        <Route path={`${match.url}/edit/:id`}
               render={(props) => <Create data={edit}
                                          filters={filters}
                                          modules={modules}
                                          title={'EDIT'}
                                          searchData={this.props.searchData}
                                          resource={resourceName}
                                          fetch={fetchResource}
                                          changed={this.props.changed}
                                          onChange={this.handleFormChange}
                                          onSubmit={this.updateResource}
                                          storeTotalData={this.storeTotalData}
                                          loading={loading}
                                          clearProps={this.props.clearProps}
                                          updateVendor={this.props.updateVendor}
                                          {...props}
               />
               }/>
      </Switch>
    </div>)
  }
}

const mapStateToProps = ({auth, invoiceEntry, commonData}) => {
  return {
    authUser: auth.authUser,
    total: invoiceEntry.total,
    data: invoiceEntry.resources,
    resource: invoiceEntry.resource,
    edit: invoiceEntry.edit,
    query: invoiceEntry.query,
    loading: commonData.loading,
    filters: commonData.filters,
    labourData: invoiceEntry.labourTotal,
    sparesData: invoiceEntry.sparesTotal,
    modules: commonData.modules,
    tpw: invoiceEntry.tpwSno,
    searchData: commonData.relationshipSearch,
    quotations: invoiceEntry.quotations,
    subDocumentFilters: commonData.subDocumentFilters,
    activities: invoiceEntry.activitySno,
    changed: invoiceEntry.changed,
    totalData: invoiceEntry.totalData,
    tableData: invoiceEntry.tableData,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getResource,
    getResourceForDownload,
    createResource,
    fetchResource,
    saveResourceQuery,
    fetchFilter,
    updateResource,
    deleteResource,
    fetchTpwNo,
    fetchQuotations,
    fetchSubDocumentFilter,
    clearProps,
    fetchActivitySno,
    setValueForTotalSpare,
    setValueForTotalLabour,
    setValueForTotal,
    fetchFormData,
    updateVendor,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(InvoiceEntry);
